import React from 'react';
import ReactDOM from 'react-dom';
import longan from '@fx/longan-sdk';
import 'antd/dist/antd.less';
// 以下文件引用勿删（部分页面本地开发样式正常 部署到环境之后样式缺失 需要手动import一下） 全局antd样式修改
import '@/assets/css/Global.module.scss';
import '@/components/Path/index.module.scss';
import '@/components/FormTablePage/index.module.scss';
import '@/components/TableOperation/index.module.scss';
import 'braft-editor/dist/index.css';
import '@/components/DefaultPage/index.module.scss';
import '@/pages/Operation/Business/components/Calendar.module.scss';
import '@/components/SelectRegion/index.module.scss';
import '@/pages/Settings/components/PairList.module.scss';
import '@/components/SelectShopModal/index.module.scss';
import '@/components/FormTablePage/components/index.module.scss';
import '@/pages/User/UserOperate/index.module.scss';
import '@/pages/Merchant/Manage/Add/Components/common.module.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

longan.start({
  project_name: 'fs-manage', // 项目名称
  env: {
    online: ['fs.sf-express.com', 'fs.szfx.com'],
  },
  filter_fields: ['position_name'], // 过滤掉不想上传的字段
  additional_info: {}, // 自定义信息
  hash_route: true, // 开启代表有hash路由流量统计
  filter_error_msg: [
    'ResizeObserver',
    'Script',
    'Unable to preload CSS',
    'Failed to fetch dynamically',
  ], // 过滤不想上报的错误。使用indexOf做匹配，请传errorMessage的关键字
});
